'use strict';

var _require = require('espo'),
    PathQuery = _require.PathQuery,
    Query = _require.Query,
    Computation = _require.Computation;

var _require2 = require('emerge'),
    equal = _require2.equal;

var _require3 = require('fpx'),
    ifonly = _require3.ifonly,
    rest = _require3.rest,
    test = _require3.test,
    isList = _require3.isList,
    validate = _require3.validate;

exports.byPath = byPath;
function byPath(observableRef, path) {
  return new PathQuery(observableRef, path, equal);
}

exports.byQuery = byQuery;
function byQuery(observableRef, query) {
  return new Query(observableRef, query, equal);
}

exports.computation = computation;
function computation(def) {
  return new Computation(def, equal);
}

exports.on = on;
function on(argPattern, fun) {
  validate(isList, argPattern);
  return ifonly(rest(test(argPattern)), fun);
}


//////////////////
// WEBPACK FOOTER
// ./~/prax/dist/misc.js
// module id = 2358
// module chunks = 118